export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-6j-af8bb629f359f4b2373f160e11983414.webp";